import { People } from "@mui/icons-material";
import { AspectRatio, Box, Card, CardOverflow, Chip, Stack, Typography } from "@mui/joy";
import { ApiCreateQuestPayload } from "griptonite-api-client/types";

import leaderboardPointsImage from "@/assets/img/quests/leaderboard-points.png";

import { Link } from "../Links";

// Each quest type is offered as a template. Its image is an illustration rather than a cover photo,
// so the cards don't look like quests that already exist.
const QUEST_TEMPLATES: {
  type: ApiCreateQuestPayload["type"];
  name: string;
  image: string;
  frequency: string;
  audience: string;
  tagline: string;
  aim: string;
}[] = [
  {
    type: "LEADERBOARD_POINTS",
    name: "Points Pursuit",
    image: leaderboardPointsImage,
    frequency: "Monthly",
    audience: "Everyone",
    tagline: "Reward climbers based on leaderboard scores",
    aim: "Encourage more frequent visits and engagement across all routes and abilities",
  },
];

export default function QuestTypeSelector() {
  return (
    <Box sx={{ padding: 2, overflowY: "auto" }}>
      <Stack gap={3}>
        <Stack gap={0.5}>
          <Typography level="h3">Choose a quest type</Typography>
          <Typography level="body-md" color="neutral">
            Quests are tailored towards different goals like attendance, engagement and
            satisfaction.
          </Typography>
        </Stack>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(240px, 280px))",
            gap: 2,
          }}
        >
          {QUEST_TEMPLATES.map((template) => (
            <Card
              key={template.type}
              variant="outlined"
              sx={{
                backgroundColor: "white",
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "primary.500",
                  transform: "translateY(-2px)",
                  boxShadow: "sm",
                },
              }}
            >
              <CardOverflow>
                <AspectRatio ratio="16/10">
                  <img src={template.image} alt="" />
                </AspectRatio>
              </CardOverflow>
              <Stack gap={1.5} sx={{ flex: 1 }}>
                <Box>
                  <Chip size="sm" variant="soft" color="primary">
                    {template.frequency}
                  </Chip>
                </Box>
                <Stack gap={0.5}>
                  {/* `overlay` stretches the link over the whole card, so the card is the link. */}
                  <Link
                    overlay
                    level="title-lg"
                    underline="none"
                    textColor="text.primary"
                    from="/gym/$venueUuid/loyalty/quests/create"
                    to="/gym/$venueUuid/loyalty/quests/create"
                    search={{ type: template.type }}
                  >
                    {template.name}
                  </Link>
                  <Typography level="body-sm" color="neutral">
                    {template.tagline}
                  </Typography>
                </Stack>
                <Typography level="body-md">{template.aim}</Typography>
                <Typography
                  level="body-xs"
                  color="neutral"
                  startDecorator={<People fontSize="small" />}
                  sx={{ marginTop: "auto" }}
                >
                  {template.audience}
                </Typography>
              </Stack>
            </Card>
          ))}
        </Box>
      </Stack>
    </Box>
  );
}
